import React, { createContext, useContext, useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchGames } from "../lib/api";

const GameCtx = createContext(null);

export const GameProvider = ({ children }) => {
  const [gameId, setGameIdState] = useState(() => {
    if (typeof window === "undefined") return "wardogs";
    return localStorage.getItem("wd.game") || "wardogs";
  });

  const { data: games = [], isLoading, isError, refetch } = useQuery({
    queryKey: ["games"],
    queryFn: fetchGames,
    refetchInterval: 60000,
    retry: 2,
    retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
    staleTime: 30000,
  });

  const setGameId = (id) => {
    setGameIdState(id);
    localStorage.setItem("wd.game", id);
  };

  useEffect(() => {
    if (!isLoading && games.length && !games.some((g) => g.id === gameId)) {
      setGameId(games[0].id);
    }
  }, [games, gameId, isLoading]);

  const game = games.find((g) => g.id === gameId) || games[0];

  // Group games by source for the picker UI
  const byGroup = games.reduce((acc, g) => {
    const key =
      g.source === "wardogs" ? "Wardogs (Live)" :
      g.source === "steam" ? "Steam (Live)" :
      g.source === "battlebit" ? "BattleBit (Live)" :
      g.source === "minecraft" ? "Minecraft (Live)" :
      g.source === "mock_demo" ? "Simulated Demos" :
      "Other";
    acc[key] = acc[key] || [];
    acc[key].push(g);
    return acc;
  }, {});

  return (
    <GameCtx.Provider value={{ games, game, gameId, setGameId, isLoading, isError, refetch, byGroup }}>
      {children}
    </GameCtx.Provider>
  );
};

export const useGame = () => {
  const ctx = useContext(GameCtx);
  if (!ctx) throw new Error("useGame must be used inside GameProvider");
  return ctx;
};
